module.exports = __webpack_public_path__ + "img/service-juece1.97aa6d56.svg";